import { render, staticRenderFns } from "./PersonalizationTags.vue?vue&type=template&id=8e86757e&scoped=true&"
import script from "./PersonalizationTags.vue?vue&type=script&lang=js&"
export * from "./PersonalizationTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e86757e",
  null
  
)

export default component.exports